import { useTranslation } from "next-i18next";
import { currency } from "utils";
import useMediaQuery from "@mui/material/useMediaQuery";
import ProgressBar from "./ProgressBar";
import classes from "./CartDrawerMessage.module.scss";

interface CartDrawerMessageProps {
  showOrderMinimumUnmetSection: boolean | null;
  amountToReachOrderMinimum: number;
  orderMinimumAmount: number;
  isDeliveryAvailable: boolean | null;
}

function CartDrawerMessage(props: CartDrawerMessageProps) {
  const { t } = useTranslation("common");
  const {
    showOrderMinimumUnmetSection,
    amountToReachOrderMinimum,
    orderMinimumAmount,
    isDeliveryAvailable,
  } = props;

  const isMobile = useMediaQuery("(max-width:60em)");
  const progressPercent =
    100 - Math.round((100 * amountToReachOrderMinimum) / orderMinimumAmount);

  return (
    <div className={classes["cart-flyout__shipping"]}>
      <div className={classes["cart-flyout-delivery"]}>
        {showOrderMinimumUnmetSection ? (
          isMobile ? (
            <ProgressBar
              progress={progressPercent}
              amountToReachOrderMinimum={amountToReachOrderMinimum}
              orderMinimumAmount={orderMinimumAmount}
            />
          ) : (
            <p className={classes["cart-flyout-delivery-amount"]}>
              {t("checkout.minimum_unmet.add_text")}
              <span className="red--text">
                {currency.format(amountToReachOrderMinimum)}
              </span>
              <span>{t("checkout.minimum_unmet.minimum_text")}</span>
              <span className="red--text">
                {currency.format(orderMinimumAmount)}
              </span>
            </p>
          )
        ) : isDeliveryAvailable ? (
          <p className={classes["cart-flyout-delivery-message"]}>
            {t("cart.ship.free_delivery")}
          </p>
        ) : null}
      </div>
    </div>
  );
}

export default CartDrawerMessage;
